import React, { useState } from 'react';
import styled from 'styled-components';
import { useDocument } from 'react-firebase-hooks/firestore';
import firebase from 'firebase/app';
import 'firebase/firestore';

import * as serviceWorker from '../serviceWorker';

import { Notification } from './Notification';

const db = firebase.firestore();

export const VersionCheck = ({ version }) => {
  const { loading, value } = useDocument(db.doc('rollouts/appVersion'));
  const versionDoc = loading ? null : value.data();
  const versionData = loading ? null : versionDoc && versionDoc.version;
  const [newVersion, setNewVersion] = useState(loading ? version : versionData);

  if (versionData > version) {
    localStorage.setItem('version', versionData);

    if (newVersion !== versionData) {
      setNewVersion(versionData);
    }
  }

  const runUpdate = () => {
    serviceWorker.unregister();
    window.location.reload(true);
  };
  return (
    <>
      {newVersion > version && (
        <Notification color="green" fullWidth={true}>
          <h4>There's an update available!</h4>
          <Button onClick={runUpdate}>Tap to update here</Button>
        </Notification>
      )}
    </>
  );
};

const Button = styled.button`
  background: transparent;
  border: none;
  font-size: 1.2rem;
  padding: 0;
  border-bottom: 1px black solid;
`;
